export function GuidGenerator() {
      return crypto.randomUUID();
    }